<template>
  <v-container :style="{ 'margin-top': $vuetify.breakpoint.xs ? '-50px' : '-50px' }">
    <v-row align="center" justify="center">
      <v-col cols="12" md="6">
        <v-img
          style="margin: auto"
          src="@/assets/logo.png"
          alt="Logo"
          :max-width="$vuetify.breakpoint.xs? '150' : '200'"
          :height="$vuetify.breakpoint.xs ? '150' : '200'"
          aspect-ratio="1"
          contain
        />
        <h2 class="text-center" :style="{ fontSize: $vuetify.breakpoint.xs ? '1.1em' : '' }">
          Die Gleitschirm Gebrauchtmarkt-Suche
        </h2>
        <p class="text-center">
          Finde dein Gleitschirm-Equipment schnell und einfach in verschiedenen
          Gebrauchtmärkten
        </p>
        <v-text-field
          :loading="loading"
          append-icon="mdi-magnify"
          solo
          dense
          class="mb-4"
          label="Suchbegriff"
          hint=""
          variant="solo"
          hide-details
          single-line
          clearable
          v-model="searchKey"
          @click:append-inner="onClickSearch"
          @keyup.enter="onClickSearch"
          @click:append="onClickSearch"
          @keypress.native.enter="onClickSearch"
          @input="onSearchFieldInput"
        ></v-text-field>

        <v-checkbox
          v-if="searchKey && searchKey.trim().split(' ').length > 1"
          label="Alle eingegebenen Wörter müssen im Ergebnis vorhanden sein"
          v-model="exactSearch"
          :disabled="loading"
          
        >
        </v-checkbox>

        <!--
        <p class="text-center text--secondary mt-2">
          Suche Gebrauchtes an verschiedenen Stellen
        </p>
        -->
        <p v-if="resultsFound" class="text-left pt-4 d-flex justify-space-between align-center">
          <span>Gefundene Ergebnisse: {{ Object.keys(results).length }}</span>
          
          <span>
            <v-btn v-if="supportShareApi && isMobileDevice" icon large @click="onClickShare" class="mr-6">
              <v-icon size="36" color="">mdi-share-variant</v-icon>
            </v-btn>
            <v-btn icon large @click="onClickFavIcon">
              <v-icon size="36" :color="(favIconClicked || searchValueIsFav)?'#ffd03a':''">mdi-star-plus</v-icon>
            </v-btn>
          </span>
        </p>

        <!-- No Results Found -->
        <div
          v-if="noResultsFound"
          class="text-center mt-5"
        >
          <v-img
            style="margin: auto"
            src="@/assets/no-results.png"
            alt="No Results"
            max-width="200"
          />
          <p>Keine Ergebnisse gefunden</p>
          <p class="mt-4 text--grey" v-if="hasLogin">
            <span v-if="!searchValueIsFav">Möchtest du eine Benachrichtigung erhalten, wenn es Neuigkeiten gibt?<br>Dann füge es deinen Favoriten hinzu.</span>
            <span v-else>Möchtest du keine Benachrichtigung mehr erhalten, wenn es Neuigkeiten gibt?<br>Dann entferne es aus deinen Favoriten.</span>
            <v-btn icon large @click="onClickFavIcon">
              <v-icon size="36" :color="(favIconClicked || searchValueIsFav)?'#ffd03a':''">mdi-star-plus</v-icon>
            </v-btn>
          </p>
        </div>

        <v-expand-transition>
          <v-card v-if="!token && (favIconClicked || noResultsFound) && !forceToClosePopup" class="mb-10">
            <v-card-text style="color: rgba(0, 0, 0, .6);">
              Wir benachrichtigen dich, wenn es Neuigkeiten für deinen Suchbegriff gibt.
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="onClickPopupMoreInfo"
                    style="cursor: pointer;"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>Mehr Informationen</span>
              </v-tooltip>
              <v-text-field
                append-icon="mdi-send"
                density="compact"
                  prepend-inner-icon="mdi-email-outline"
                  variant="outlined"
                  type="email"
                label="Deine E-Mail Adresse"
                hint=""
                hide-details
                single-line
                v-model="subscriberMail"
                @click:append-inner="onClickSubscribe"
                @click:append="onClickSubscribe"
                @keypress.native.enter="onClickSubscribe"
              ></v-text-field>
              </v-card-text>
          </v-card>
        </v-expand-transition> 
          <!-- Popover -->
          <v-dialog v-model="popover.show" max-width="400">
            <v-card>
              <v-card-title class="text-h6">{{popover.title}}</v-card-title>
              <v-card-text>
                {{popover.text}}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="onClickPopupClose">Schließen</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        


        <!-- Skeleton loader while loading -->
        <v-skeleton-loader
          v-if="loading"
          type="article"
          :loading="loading"
          style="margin-top:10px;"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="loading"
          type="article"
          :loading="loading"
        ></v-skeleton-loader>
        <v-skeleton-loader
          v-if="loading"
          type="article"
          :loading="loading"
        ></v-skeleton-loader>

        <!-- Results as Cards -->
        <v-row v-if="!loading">
          <v-col cols="12" v-for="(linkObj, link) in results" :key="link">
            <a :href="link" target="_blank" class="text-decoration-none">
              <v-card class="hoverable">
                <v-row no-gutters>
                  <!-- Image on the left -->
                  <v-col cols="3">
                    <v-img
                      :src="linkObj.img || '@/assets/no-image.png'"
                      alt="Image associated with the link"
                      lazy-src="@/assets/no-image.png"
                      class="rounded"
                      aspect-ratio="1"
                    >
                    </v-img>
                  </v-col>

                  <v-col v-if="isMobile" cols="7" class="pa-2">
                    <div class="text-container">
                      <span class="font-weight-bold">
                        {{ formatLabel(linkObj.label) }}
                      </span>
                    </div>
                    <div class="text--secondary" style="font-size: small;">
                      {{getDomain(link)}}
                    </div>
                  </v-col>

                  <!-- Description in the middle -->
                  
                  <v-col v-else cols="7" class="pa-2">
                    <div class="text-container" style="padding-left:16px; font-size: 1.1em; display: flex; flex-direction: column; height: 100%; justify-content: space-between;">
                      <!-- Hauptinhalt -->
                      <span class="text-container font-weight-bold">
                        {{ formatLabel(linkObj.label) }}
                      </span>

                      <!-- Footer (v-card-subtitle immer unten) -->
                      <v-card-subtitle style="padding-bottom:0px;padding-left:0px;">
                        {{ getDomain(link) }}
                      </v-card-subtitle>
                    </div>
                  </v-col>
                  <!-- Arrow on the right -->
                  <v-col cols="2" class="d-flex align-center justify-center">
                    <v-icon color="primary">mdi-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </v-card>
            </a>
          </v-col>
        </v-row>

        <!-- Paypal -->
        <PayPalButton v-show="resultsFound"
        class="mt-10"
          :amount="1"
          @payment-success="handleSuccess"
          @payment-error="handleError"
        />

        <!-- -Sources -->
        <div v-if="resultsFound" class="mt-10">
        <p class="text-left"></p>
          <div class="pb-3" style="color:grey"><b>Ergebnisse gefunden auf:</b></div>
          <div v-for="(url) in foundUrls"  :key="url" style="color:grey">
            {{ url }}
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import PayPalButton from "./PayPalButton.vue";

import apiMethods from '@/mixins/apiMethods.js';
export default {
  mixins:[apiMethods],
  data() {
    return {
      searchKey: "",
      subscriberMail:"",
      exactSearch: true,
      results: {},
      isMobile: false,
      requestSent: false,
      loading: false,
      favIconClicked:false,
      popover: {
        show:false,
        text:'',
        title:'',
        onClose:null
      },
      forceToClosePopup:false
    };
  },
  components:{
     PayPalButton,
  },
  computed:{

    noResultsFound(){
      return !this.loading && Object.keys(this.results).length === 0 && this.requestSent;
    },
    resultsFound(){
      return !this.loading && Object.keys(this.results).length > 0 && this.requestSent;
    },
    searchValueIsFav() {
      if (!this.subscribedTopics || !this.searchKey) {
        return false;
      }

      const searchKeyLower = this.searchKey.toLowerCase();
      return Object.keys(this.subscribedTopics).some(
        (key) => key.toLowerCase() === searchKeyLower
      );
    },

    foundUrls(){
      const domains= Object.keys(this.results).map((url) => {
        return this.getDomain(url);
      });
      return [...new Set(domains)];
    }
  },
  mounted() {
    this.checkUrlParams();
    this.checkMobileDevice();
    window.addEventListener("resize", this.checkMobileDevice); 
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobileDevice); 
  },
  methods: {
    onClickPopupMoreInfo(){
      this.popover.show=true;
      this.popover.title="E-Mail-Benachrichtigung";
      this.popover.text="Trage deine E-Mail-Adresse ein, um automatisch Updates für deinen Suchbegriff zu erhalten. Wir durchsuchen täglich verschiedene Gebrauchtmärkte und informieren dich per E-Mail über neue Einträge. Du kannst die Benachrichtigungen jederzeit abbestellen.";
    },
    onClickPopupEmailEntered(){
      if(!this.hasLogin){
        this.popover.show=true;
        this.popover.title="E-Mail-Benachrichtigung";
        this.popover.text="Deine Suche wurde gespeichert! Wir haben dir eine E-Mail mit deinen Login-Informationen zugesandt. Bitte schaue in deinem E-Mail Postfach nach – überprüfe auch den Spam-Ordner, falls die E-Mail nicht in deinem Posteingang zu finden ist.";
        this.popover.onClose=()=>{
          this.forceToClosePopup=true;
        }
      }
    },
    onClickPopupClose(){
      this.popover.show = false;
      if(typeof(this.popover.onClose)=="function"){
        this.popover.onClose();
      }
      this.popover.onClose=null;
    },
    onSearchFieldInput(){
      this.favIconClicked=false;
    },
    onClickSearch(){
      if (!this.searchKey || this.searchKey.trim().length <= 1){
        return;
      }
      this.loading = true;
      this.requestSent = false;
      
      this.search(this.searchKey,this.exactSearch,()=>{
        this.loading = false;
        this.requestSent = true;
        this.setUrlInBrowser();
      });
    },
    setUrlInBrowser(){
      try {
        if(window && window.history){
          window.history.pushState({}, '', this.getSearchParams(this.searchKey,this.exactSearch));
        }
      } catch (error) {
        console.error(error);
      }
    },
    onClickShare(){
      if(this.supportShareApi){
        //const host=window.location.hostname;
        const url=this.getSearchParams(this.searchKey,this.exactSearch);
        this.share(this.searchKey,'\nSchau dir das mal an\n',url);
      }
    },
    onClickFavIcon(){
      this.favIconClicked=!this.favIconClicked;
      this.forceToClosePopup=false;
      if(this.searchValueIsFav){
        this.favIconClicked=false;
      }
      
      if(this.token){
        if(this.favIconClicked){
          this.subscribe(this.mail, this.token, this.searchKey,this.exactSearch);
        }else{
          this.unsubscribe(this.token,this.searchKey);
        }
        
      }
    },
    onClickSubscribe(){
      if(this.searchKey.trim().length>0 && (this.isValidEmail(this.subscriberMail) || this.token)){
         this.subscribe(this.subscriberMail,this.token,this.searchKey,this.exactSearch,()=>{
            this.onClickPopupEmailEntered()
         });
      }
    },
    handleSuccess(details) {
      console.log("Zahlung erfolgreich:", details);
    },
    handleError(error) {
      console.error("Zahlungsfehler:", error);
    },

    checkMobileDevice() {
      this.isMobile = window.innerWidth <= 768; 
    },

    checkUrlParams(){
      const urlParams = new URLSearchParams(window.location.search);
      const search = urlParams.get("search");
      const exact = urlParams.get("exact");
      
      if(exact=="false" || exact=="0"){
        this.exactSearch=false;
      }else{
        this.exactSearch=true;
      }
      
      if(search && search.trim().length>0){
        this.searchKey=search;
        this.onClickSearch();
      }

    },

    formatLabel(label) {
      const parser = new DOMParser();
      const decoded = parser.parseFromString(label, "text/html").documentElement
        .textContent;
      return decoded || label;
    },
    getDomain(url) {
      try {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname; // Extracts the domain (e.g., 'example.com')
      } catch (error) {
        console.log(url);
        console.error('Invalid URL', error);
      }
      return '';
    }
  }
};
</script>

<style scoped>
.text-container {
  display: -webkit-box; /* Verwendet ein flexibles Box-Modell */
  -webkit-line-clamp: 2; /* Begrenzung auf 2 Zeilen */
  -webkit-box-orient: vertical; /* Definiert die Box-Ausrichtung vertikal */
  overflow: hidden; /* Verhindert das Anzeigen von überflüssigem Text */
  white-space: normal; /* Ermöglicht das Umbruchverhalten des Textes */
}
</style>
